import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles
} from '@material-ui/core';

import Fido from "../utils/Fido";
import Constants from "../utils/Constants";
import FormHelper from "../utils/FormHelper";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import PaddedLayout from "../components/PaddedLayout";
import EntityMetricsReport from "../reports/containers/EntityMetricsReport";
import EntityDetailsForm from "../components/EntityDetailsForm";

const styles = makeStyles(theme => ({
	fullScreenClassName: {
		[theme.breakpoints.only('sm')]: {
			paddingTop: `${theme.spacing(28.375)}px !important`
		}
	}
}));

const defaultFormValues = Object.assign({}, {locations: []});
function EntityDetails(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);

	const [entityId, setEntityId] = useState(null);
	//const [entity, setEntity] = useState(null);
	const [formValues, setFormValues] = useState(defaultFormValues);
	const [accountLocations, setAccountLocations] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [locationsLoading, setLocationsLoading] = useState(false);
	const [searchTermSuggestion, setSearchTermSuggestion] = useState("");

	let classes = styles(),
		{updateHeader, resetHeader, showSnackbar, history,
			location, type, setFullScreenClassName/*, showBanner*/} = props;

	// load account locations
	useEffect(() => {
		let barkley = new Fido();
		setLocationsLoading(true);
		(async function loadAccountLocations() {
			let data = await barkley.fetch(`/accounts/${authenticatedUser.account_id}/locations`, {
				query: {active: 1}
			})
				.catch(error => {
					return showSnackbar(error.message);
				});

			if (data) {
				setAccountLocations(data);
				setLocationsLoading(false);
			}
		})();

		return () => barkley.dropIt();
	}, [setAccountLocations, showSnackbar, authenticatedUser, setLocationsLoading]);

	// get id from url (edit)
	useEffect(() => {
		let urlParams = location.pathname.split('/'),
			id = Number(urlParams[3]);

		if (!isNaN(id)) {
			setEntityId(id);
		} else {
			setEntityId(false);
		}
	}, [entityId, setEntityId, location]);

	// load the entity if id found in url
	useEffect(() => {
		let fido = new Fido();
		if (entityId) {
			//setEntity(null);
			setIsLoading(true);
			(async function loadEntity() {
				let data = await fido.fetch(`/entities/${entityId}`)
					.catch(error => {
						return showSnackbar(error.message);
					});

				if (data) {
					//setEntity(data);
					setIsLoading(false);
					setFormValues(Object.assign({}, defaultFormValues, data));
				}
			})();
		}

		return () => fido.dropIt();
	}, [/*setEntity,*/ showSnackbar, entityId, setFormValues, setIsLoading]);

	// set header / title
	useEffect(() => {
		let prefix = entityId ? "Edit" : "Add",
			suffix = Constants.ENTITIES.getName(type),
			title = `${prefix} ${suffix}`;

		updateHeader({
			primary: false,
			title: title
		});

		if (entityId) {
			setFullScreenClassName(classes.fullScreenClassName);
		}

		return () => resetHeader();
	}, [updateHeader, resetHeader, type, entityId, setFullScreenClassName]);

	const searchTermSuggestionChange = (event) => {
		setSearchTermSuggestion(event.target.value);
	};

	const searchTermSuggestionHandler = () => {
		let simon = new Fido();
		simon.fetch(`/entities/${formValues.id}/search-terms-suggestion`, {
			method: "POST",
			body: JSON.stringify(Object.assign({}, formValues, {searchTermSuggestion: searchTermSuggestion}))
		}, "Submitting Suggestions...", "Suggestions Submitted.")
			.catch(error => showSnackbar(error.message));
	};

	const handleFormChange = (event) => {
		let fVals = Object.assign({}, formValues);
		setFormValues(Object.assign(fVals, FormHelper.getChanged(event)));
	};

	const submit = (formValues) => {
		let name = Constants.ENTITIES.getName(type),
			fVals = Object.assign({}, formValues),
			successMsg = entityId ? "Saved." : `${name} Added.`,
			msg = entityId ? `Saving ${name}...` : `Adding ${name}...`,
			url = entityId ? `/entities/${formValues.id}` : "/entities/add";

		fVals.type = type;
		fVals.locations = fVals.locations && fVals.locations.split(',') || null;

		let poodle = new Fido();
		poodle.fetch(url, {
			method: entityId ? "PUT" : "POST",
			body: JSON.stringify(fVals)
		}, msg, successMsg)
			.then(data => {
				history.goBack();
			})
			.catch(error => showSnackbar(error.message));

		/*showBanner({
			content: entityId ?
				`New ${Constants.ENTITIES.getName(type, true)} may take a few moments to be fully created.` :
				"It may take a few moments for changes to take effect.",
			actions: [
				{text: "Dismiss", handler: () => showBanner(false)}
			]
		});*/
	};

	const deleteHandler = (eventId) => {
		let poodle = new Fido(),
			name = Constants.ENTITIES.getName(type);

		poodle.fetch(`/entities/${entityId}/delete`, {
			method: "DELETE"
		}, `Deleting ${name}...`, `${name} Deleted.`)
			.then((data) => {
				history.goBack();
			})
			.catch(error => showSnackbar(error.message));
	};

	return (
		<React.Fragment>
			{entityId ?
				<EntityMetricsReport
					type={type}
					showSnackbar={showSnackbar}
					location={location}
					entityId={entityId}
					searchTermSuggestion={searchTermSuggestion}
					suggestionChange={searchTermSuggestionChange}
					suggestionHandler={searchTermSuggestionHandler} /> : null
			}
			<PaddedLayout noTopPad={entityId ? true : false}>
				<EntityDetailsForm
					type={type}
					isLoading={isLoading}
					dataLoading={locationsLoading}
					accountLocations={accountLocations}
					formValues={formValues}
					showSnackbar={showSnackbar}
					deleteEventHandler={deleteHandler}
					handleChange={handleFormChange}
					handleSubmit={submit}
					handleCancel={() => history.goBack()} />
			</PaddedLayout>
		</React.Fragment>
	);
}

EntityDetails.propTypes = {
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired,
	showBanner: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	type: PropTypes.number,
	setFullScreenClassName: PropTypes.func
};

export default EntityDetails;